export default class {
    constructor() {
        this.subscribers = new Set();
    }
    notify(id, updated) {
        this.subscribers.forEach((f) => { f(id, updated); });
    }
    subscribe(f) {
        this.subscribers.add(f);
    }
    unsubscribe(f) {
        this.subscribers.delete(f);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/base/Subscribtion.js